<template>
  <div class="relative">
    <Menu as="div" class="relative">
      <MenuButton
        :disabled="disabled"
        class="w-10 cursor-pointer select-none space-x-1 rounded-sm bg-primary-95 px-3 py-2 text-center text-sm font-medium text-primary-40 ring-offset-2 hover:bg-primary-90 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-primary-80"
      >
        {{ t(`logicalOperator.${operator}`) }}</MenuButton
      >
      <MenuItems
        as="ul"
        class="absolute top-11 z-20 flex w-11 flex-col rounded-md border bg-white shadow focus:outline-none"
      >
        <MenuItem v-slot="{ active }" as="template">
          <li
            :class="[{ 'bg-primary-95': active }, 'cursor-pointer select-none px-4 py-2 text-sm text-neutral-70']"
            @click="updateOperator('and')"
          >
            <span>{{ t("logicalOperator.and") }}</span>
          </li>
        </MenuItem>
        <MenuItem v-slot="{ active }" as="template">
          <li
            :class="[{ 'bg-primary-95': active }, 'cursor-pointer select-none px-4 py-2 text-sm text-neutral-70']"
            @click="updateOperator('or')"
          >
            <span>{{ t("logicalOperator.or") }}</span>
          </li>
        </MenuItem>
      </MenuItems>
    </Menu>
  </div>
</template>

<script lang="ts" setup>
// Components
import { Menu, MenuButton, MenuItems, MenuItem } from "@headlessui/vue";

// Utils
import { useI18n } from "vue-i18n";

// Types
import type { Operator } from "@/vue/types/predicates";

const { t } = useI18n();

withDefaults(
  defineProps<{
    operator: Operator;
    disabled?: boolean;
  }>(),
  {
    disabled: false,
  },
);

const emit = defineEmits<{
  (e: "update:concatenator", operator: Operator): void;
}>();

const updateOperator = (operator: Operator) => {
  emit("update:concatenator", operator);
};
</script>
